import { Badge } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const TabLabel = styled('div')`
    display: flex;
    align-items: center;
    gap: 4px;
`;
export const StyledBadge = styled(Badge)`
    position: relative !important;
    transform: none !important;
    > div {
        position: relative !important;
        transform: none !important;
    }
`;
